export default class WindowHelper {
  static openInNewTab(href, target = '_blank'){
    Object.assign(document.createElement('a'), {
      target: target,
      rel: 'noopener noreferrer',
      href: href
    }).click();
  }
}
